/* eslint-disable jsx-a11y/anchor-is-valid */
import {useDeleteGroup, useFindAllGroups} from "hooks/query/group-query"
import {GroupTree} from "pages/group/GroupTree"
import {useState} from "react"
import {RegisterGroup} from "pages/group/RegisterGroup"
import {NotificationType, showNotification} from "common/Notification"
import {useNavigate} from "react-router-dom"

export const GroupListView = () => {
    const navigate = useNavigate()
    const [showRegisterWindow, setShowRegisterWindow] = useState<boolean>()
    const [selectedNode, selectNode] = useState<TreeNodeData | undefined>()
    const {data: groups} = useFindAllGroups()
    const deleteMutate = useDeleteGroup()

    const deleteGroup = () => {
        if (!selectedNode) {
            showNotification("삭제할 그룹이 선택되지 않았습니다", NotificationType.WARNING)
            return
        }
        if (!window.confirm("삭제하시겠습니까?")) return

        deleteMutate.mutate(selectedNode.id, {
            onSuccess: () => showNotification("그룹이 삭제되었습니다", NotificationType.SUCCESS),
            onError: () => showNotification("그룹을 삭제하지 못했습니다")
        })
    }
    return (
        <div className="main-body">
            <div className="level mb0">
                <div className="level-left">
                    <h5 className="is-size-5 has-text-weight-bold ml5">Groups</h5>
                </div>
                <div className="level-right">

                </div>
            </div>

            <div className="main-panel">

                <div className="columns ml10 mt10">
                    <div className="column is-two-thirds">
                        <div className="panel-02">
                            <div className="">
                                <div className=" is-size-6 has-text-weight-bold">
                                    Group list
                                </div>

                            </div>

                            {groups && (
                                <GroupTree groups={groups} selectedNode={selectedNode} selectNode={selectNode}/>
                            )}
                        </div>
                    </div>
                    <div className="column mt30">
                        <a className="button is-purple2 is-size-85" onClick={() => setShowRegisterWindow(true)}>
                            <span className="icon is-small">
                                <i className="fas fa-plus"/>
                            </span>
                            <span>Group 추가</span>
                        </a>
                        <a className="button is-size-85 ml-2" onClick={() => {
                            if (!selectedNode || !selectedNode.id) {
                                showNotification("수정할 Group를 선택하세요")
                                return
                            }
                            navigate(`/group/update/${selectedNode.id}/form`)
                        }}>
                            <span>수정</span>
                        </a>
                        <a className="button is-size-85 ml-2" onClick={() => deleteGroup()}>
                            <span>삭제</span>
                        </a>
                    </div>
                </div>

                {showRegisterWindow && (
                    <RegisterGroup close={() => setShowRegisterWindow(false)} parentId={selectedNode?.id}/>
                )}
            </div>
        </div>
    )
}

export type TreeNodeData = {
    title: string,
    id: string,
    isLeaf?: boolean
    children?: TreeNodeData[]
    expanded?: boolean
}